import CampanaNotificaciones from "./CampanaNotificaciones";
import BotonInstructivo from "./BotonInstructivo";
import BotonMapaProceso from "./BotonMapaProceso";
import { useState } from "react";
import { subirDatos, eliminarDato } from "./syncSupabase";

const tiposCliente = ["Nacional", "Internacional", "Exportación", "Distribuidores", "Minorista"];
const estadosCliente = { activo: { label: "✅ Activo", color: "#22c55e" }, inactivo: { label: "⛔ Inactivo", color: "#e63946" }, prospecto: { label: "🔵 Prospecto", color: "#3b82f6" }, suspendido: { label: "🟡 Suspendido", color: "#f59e0b" } };
const segmentosCliente = ["Premium", "Estándar", "Gobierno", "Industria farmacéutica", "Cosmética", "Alimentos", "Retail", "Otro"];

function generarCodCliente(lista) { return `CLI-${String(lista.length + 1).padStart(4, "0")}`; }

export default function Clientes({ onVolver, oscuro, usuario }) {
  const [clientes, setClientes] = useState(() => {
    try { return JSON.parse(localStorage.getItem('alqos_clientes') || '[]'); } catch { return []; }
  });
  const [vista, setVista] = useState("listado");
  const [form, setForm] = useState({ estado: "activo", tipo: "Nacional", segmento: "Estándar" });
  const [detalle, setDetalle] = useState(null);
  const [confirmEliminar, setConfirmEliminar] = useState(null);
  const [busqueda, setBusqueda] = useState("");
  const [filtroEstado, setFiltroEstado] = useState("todos");
  const [nuevaNC, setNuevaNC] = useState({ fecha: new Date().toISOString().slice(0, 10) });
  const [mostrarFormNC, setMostrarFormNC] = useState(false);

  const bg = oscuro ? "#09184D" : "#F0EEFF";
  const cardBg = oscuro ? "#0d2160" : "white";
  const texto = oscuro ? "#EDF2FA" : "#2F3E2E";
  const borde = oscuro ? "#1e3a8a" : "#eee";
  const navBg = oscuro ? "#060f30" : "#09184D";
  const subtexto = oscuro ? "#9aabd4" : "#808085";
  const esAdmin = usuario?.rol === "Administrador";

  const inp = { width: "100%", padding: "8px 12px", borderRadius: "8px", border: `1px solid ${borde}`, fontSize: "13px", boxSizing: "border-box", marginTop: "4px", background: cardBg, color: texto, fontFamily: "sans-serif" };
  const lbl = { fontSize: "12px", color: oscuro ? "#9aabd4" : "#555", fontWeight: "600", display: "block", marginTop: "12px" };
  const card = { background: cardBg, borderRadius: "12px", padding: "1.5rem", border: `1px solid ${borde}`, marginBottom: "12px" };

  const guardar = () => {
    const nuevo = { ...form, id: Date.now(), codigo: generarCodCliente(clientes), reclamos: [], fechaCreacion: new Date().toISOString(), creadoPor: usuario?.nombre || "Sistema", rolCreador: usuario?.rol || "" };
    const nuevos = [...clientes, nuevo];
    setClientes(nuevos);
    localStorage.setItem('alqos_clientes', JSON.stringify(nuevos));
    subirDatos('alqos_clientes');
    setForm({ estado: "activo", tipo: "Nacional", segmento: "Estándar" });
    setVista("listado");
  };

  const eliminar = async (id) => {
    const nuevos = clientes.filter(c => c.id !== id);
    setClientes(nuevos);
    localStorage.setItem('alqos_clientes', JSON.stringify(nuevos));
    await eliminarDato('alqos_clientes', id);
    setConfirmEliminar(null); setDetalle(null); setVista("listado");
  };

  const cambiarEstado = (id, nuevoEstado) => {
    const actualizados = clientes.map(c => c.id === id ? { ...c, estado: nuevoEstado } : c);
    setClientes(actualizados);
    localStorage.setItem('alqos_clientes', JSON.stringify(actualizados));
    subirDatos('alqos_clientes');
    if (detalle?.id === id) setDetalle(prev => ({ ...prev, estado: nuevoEstado }));
  };

  const agregarReclamo = () => {
    if (!nuevaNC.descripcion?.trim()) return;
    const reclamo = { ...nuevaNC, id: Date.now(), registradoPor: usuario?.nombre, fechaRegistro: new Date().toISOString(), estado: "abierto" };
    const actualizados = clientes.map(c => c.id === detalle.id ? { ...c, reclamos: [...(c.reclamos || []), reclamo] } : c);
    setClientes(actualizados);
    localStorage.setItem('alqos_clientes', JSON.stringify(actualizados));
    subirDatos('alqos_clientes');
    setDetalle(prev => ({ ...prev, reclamos: [...(prev.reclamos || []), reclamo] }));
    setNuevaNC({ fecha: new Date().toISOString().slice(0, 10) });
    setMostrarFormNC(false);
  };

  const clientesFiltrados = clientes.filter(c => {
    const matchEstado = filtroEstado === "todos" || c.estado === filtroEstado;
    const matchBusqueda = !busqueda || c.nombre?.toLowerCase().includes(busqueda.toLowerCase()) || c.codigo?.toLowerCase().includes(busqueda.toLowerCase());
    return matchEstado && matchBusqueda;
  });

  const resumen = { total: clientes.length, activos: clientes.filter(c => c.estado === "activo").length, prospectos: clientes.filter(c => c.estado === "prospecto").length, totalReclamos: clientes.reduce((acc, c) => acc + (c.reclamos?.length || 0), 0) };

  const Header = ({ titulo, onBack, extra }) => (
    <div style={{ background: navBg, padding: "1rem 1.5rem", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100, marginBottom: "1.5rem" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <button onClick={onBack} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "white", padding: "6px 14px", borderRadius: "10px", cursor: "pointer", fontSize: "13px" }}>← Volver</button>
        <span style={{ color: "white", fontWeight: "700", fontSize: "16px" }}>{titulo}</span>
      </div>
      {extra}
    </div>
  );

  if (confirmEliminar) return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: cardBg, borderRadius: "16px", padding: "2rem", maxWidth: "360px", width: "90%", border: `1px solid ${borde}`, textAlign: "center" }}>
        <p style={{ fontSize: "32px", marginBottom: "1rem" }}>👥</p>
        <p style={{ fontSize: "15px", fontWeight: "600", color: texto, marginBottom: ".5rem" }}>¿Eliminar este cliente?</p>
        <p style={{ fontSize: "13px", color: subtexto, marginBottom: "1.5rem" }}>Se eliminarán también sus reclamos registrados.</p>
        <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
          <button onClick={() => setConfirmEliminar(null)} style={{ padding: "10px 20px", background: "none", border: `1px solid ${borde}`, borderRadius: "10px", cursor: "pointer", color: texto, fontSize: "13px" }}>Cancelar</button>
          <button onClick={() => eliminar(confirmEliminar)} style={{ padding: "10px 20px", background: "#e63946", border: "none", borderRadius: "10px", cursor: "pointer", color: "white", fontSize: "13px", fontWeight: "600" }}>Eliminar</button>
        </div>
      </div>
    </div>
  );

  if (vista === "detalle" && detalle) return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif" }}>
      <Header titulo={detalle.codigo}
        onBack={() => { setDetalle(null); setVista("listado"); }}
        extra={esAdmin && <button onClick={() => setConfirmEliminar(detalle.id)} style={{ background: "rgba(230,57,70,.2)", border: "1px solid rgba(230,57,70,.4)", color: "#e63946", padding: "6px 14px", borderRadius: "10px", cursor: "pointer", fontSize: "12px" }}>🗑 Eliminar</button>}
      />
      <div style={{ padding: "0 2rem 2rem", maxWidth: "700px", margin: "0 auto" }}>
        <div style={{ ...card, background: oscuro ? "#0a1f5c" : "#F0EEFF", border: `1px solid ${oscuro ? "#7B5BF2" : "#d4c8ff"}` }}>
          <h3 style={{ fontSize: "13px", fontWeight: "600", color: "#7B5BF2", marginBottom: "10px" }}>Datos del cliente</h3>
          {[["Código", detalle.codigo], ["Nombre / Razón social", detalle.nombre], ["Tipo", detalle.tipo], ["Segmento", detalle.segmento], ["CUIT", detalle.cuit], ["Contacto", detalle.contacto], ["Email", detalle.email], ["Teléfono", detalle.telefono], ["Dirección", detalle.direccion], ["País", detalle.pais], ["Vendedor asignado", detalle.vendedor], ["Creado por", `${detalle.creadoPor} — ${detalle.rolCreador}`]].map(([k, v]) => v && (
            <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", padding: "4px 0", borderBottom: `0.5px solid ${borde}` }}>
              <span style={{ color: subtexto }}>{k}</span>
              <span style={{ color: texto, fontWeight: "500", maxWidth: "60%", textAlign: "right" }}>{v}</span>
            </div>
          ))}
        </div>

        <div style={card}>
          <h3 style={{ fontSize: "14px", fontWeight: "600", color: "#7B5BF2", marginBottom: "12px" }}>Estado</h3>
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            {Object.entries(estadosCliente).map(([val, { label, color }]) => (
              <button key={val} onClick={() => esAdmin && cambiarEstado(detalle.id, val)}
                style={{ padding: "7px 12px", borderRadius: "10px", fontSize: "12px", cursor: esAdmin ? "pointer" : "default", fontWeight: "600", border: detalle.estado === val ? `2px solid ${color}` : `1px solid ${borde}`, background: detalle.estado === val ? `${color}22` : cardBg, color: detalle.estado === val ? color : subtexto }}>
                {label}
              </button>
            ))}
          </div>
        </div>

        {detalle.observaciones && <div style={card}><h3 style={{ fontSize: "14px", fontWeight: "600", color: "#09184D", marginBottom: "8px" }}>Observaciones</h3><p style={{ fontSize: "13px", color: texto, lineHeight: "1.6" }}>{detalle.observaciones}</p></div>}

        <div style={card}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
            <h3 style={{ fontSize: "14px", fontWeight: "600", color: "#e63946", margin: 0 }}>Reclamos / NCs de cliente ({detalle.reclamos?.length || 0})</h3>
            {esAdmin && <button onClick={() => setMostrarFormNC(m => !m)} style={{ padding: "5px 12px", background: "#e63946", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "12px", fontWeight: "600" }}>+ Agregar</button>}
          </div>
          {mostrarFormNC && (
            <div style={{ background: oscuro ? "#091840" : "#f7f9fd", borderRadius: "10px", padding: "1rem", marginBottom: "12px", border: `1px solid ${borde}` }}>
              <span style={lbl}>Descripción del reclamo</span>
              <textarea rows={3} value={nuevaNC.descripcion || ""} onChange={e => setNuevaNC(f => ({ ...f, descripcion: e.target.value }))} style={{ ...inp, resize: "none" }} placeholder="Detallá el reclamo del cliente..." />
              <span style={lbl}>Fecha</span>
              <input type="date" value={nuevaNC.fecha} onChange={e => setNuevaNC(f => ({ ...f, fecha: e.target.value }))} style={inp} />
              <span style={lbl}>Tipo de reclamo</span>
              <input value={nuevaNC.tipo || ""} onChange={e => setNuevaNC(f => ({ ...f, tipo: e.target.value }))} style={inp} placeholder="Ej: Calidad, Entrega, Facturación..." />
              <span style={lbl}>Impacto económico estimado</span>
              <input value={nuevaNC.impacto || ""} onChange={e => setNuevaNC(f => ({ ...f, impacto: e.target.value }))} style={inp} placeholder="$ opcional" />
              <div style={{ display: "flex", gap: "8px", marginTop: "12px" }}>
                <button onClick={agregarReclamo} style={{ flex: 1, padding: "10px", background: "#7B5BF2", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "13px", fontWeight: "600" }}>Guardar reclamo</button>
                <button onClick={() => setMostrarFormNC(false)} style={{ padding: "10px 16px", background: "none", border: `1px solid ${borde}`, borderRadius: "8px", cursor: "pointer", color: texto, fontSize: "13px" }}>Cancelar</button>
              </div>
            </div>
          )}
          {(detalle.reclamos || []).length === 0
            ? <p style={{ fontSize: "13px", color: subtexto, textAlign: "center", padding: "1rem" }}>Sin reclamos registrados</p>
            : (detalle.reclamos || []).map(r => (
                <div key={r.id} style={{ background: oscuro ? "#091840" : "#fff0f0", borderRadius: "10px", padding: "1rem", marginBottom: "8px", border: `1px solid ${oscuro ? "#3a1a1a" : "#fdd"}` }}>
                  <p style={{ fontSize: "13px", color: texto, margin: "0 0 6px", lineHeight: "1.5" }}>{r.descripcion}</p>
                  {r.tipo && <p style={{ fontSize: "11px", color: subtexto, margin: "0 0 2px" }}>Tipo: {r.tipo}</p>}
                  {r.impacto && <p style={{ fontSize: "11px", color: "#e63946", margin: "0 0 2px", fontWeight: "600" }}>Impacto: {r.impacto}</p>}
                  <p style={{ fontSize: "11px", color: subtexto, margin: 0 }}>{r.fecha} · {r.registradoPor}</p>
                </div>
              ))
          }
        </div>
      </div>
    </div>
  );

  if (vista === "nueva") return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif" }}>
      <Header titulo="Nuevo Cliente" onBack={() => setVista("listado")} />
      <div style={{ padding: "0 2rem 2rem", maxWidth: "700px", margin: "0 auto" }}>
        <div style={{ ...card, background: oscuro ? "#0a1f5c" : "#F0EEFF", border: `1px solid ${oscuro ? "#7B5BF2" : "#d4c8ff"}` }}>
          <h3 style={{ fontSize: "13px", fontWeight: "600", color: "#7B5BF2", marginBottom: "4px" }}>Trazabilidad automática</h3>
          <p style={{ fontSize: "12px", color: subtexto, margin: 0 }}>Creado por: <strong style={{ color: texto }}>{usuario?.nombre}</strong> — {usuario?.rol}</p>
        </div>
        <div style={card}>
          <h3 style={{ fontSize: "14px", fontWeight: "600", marginBottom: "8px", color: "#09184D" }}>Datos del cliente</h3>
          <span style={lbl}>Tipo</span>
          <select onChange={e => setForm(f => ({ ...f, tipo: e.target.value }))} style={inp} defaultValue="Nacional">
            {tiposCliente.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
          <span style={lbl}>Segmento</span>
          <select onChange={e => setForm(f => ({ ...f, segmento: e.target.value }))} style={inp} defaultValue="Estándar">
            {segmentosCliente.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
          <span style={lbl}>Estado inicial</span>
          <div style={{ display: "flex", gap: "8px", marginTop: "6px", flexWrap: "wrap" }}>
            {Object.entries(estadosCliente).map(([val, { label, color }]) => (
              <button key={val} onClick={() => setForm(f => ({ ...f, estado: val }))}
                style={{ padding: "7px 12px", borderRadius: "10px", fontSize: "12px", cursor: "pointer", fontWeight: "600", border: form.estado === val ? `2px solid ${color}` : `1px solid ${borde}`, background: form.estado === val ? `${color}22` : cardBg, color: form.estado === val ? color : texto }}>
                {label}
              </button>
            ))}
          </div>
          {[{ key: "nombre", label: "Razón social / Nombre" }, { key: "cuit", label: "CUIT" }, { key: "contacto", label: "Persona de contacto" }, { key: "email", label: "Email" }, { key: "telefono", label: "Teléfono" }, { key: "direccion", label: "Dirección" }, { key: "pais", label: "País" }, { key: "vendedor", label: "Vendedor asignado" }, { key: "condicionesPago", label: "Condiciones de pago" }, { key: "observaciones", label: "Observaciones", multiline: true }].map(({ key, label, multiline }) => (
            <div key={key}>
              <span style={lbl}>{label}</span>
              {multiline ? <textarea rows={3} onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))} style={{ ...inp, resize: "none" }} /> : <input onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))} style={inp} />}
            </div>
          ))}
        </div>
        <button onClick={guardar} style={{ width: "100%", padding: "14px", background: "#7B5BF2", color: "white", border: "none", borderRadius: "10px", fontSize: "15px", fontWeight: "600", cursor: "pointer", marginTop: "1rem" }}>
          Guardar Cliente
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif" }}>
      <div style={{ background: navBg, padding: "1rem 1.5rem", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <button onClick={onVolver} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "white", padding: "6px 14px", borderRadius: "10px", cursor: "pointer", fontSize: "13px" }}>← Menú</button>
          <BotonInstructivo moduloKey="clientes" oscuro={oscuro} />
          {usuario?.rol === "Administrador" && <BotonMapaProceso moduloKey="clientes" oscuro={oscuro} />}
          <span style={{ color: "white", fontWeight: "700", fontSize: "16px" }}>Clientes</span>
        </div>
        <CampanaNotificaciones oscuro={oscuro} modulo="Clientes" />
          {esAdmin && <button onClick={() => setVista("nueva")} style={{ padding: "6px 14px", background: "#7B5BF2", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "13px", fontWeight: "600" }}>+ Nuevo</button>}
      </div>
      <div style={{ padding: "1rem 1.5rem" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: "10px", marginBottom: "1.5rem" }}>
          {[["Total", resumen.total, "#7B5BF2"], ["Activos", resumen.activos, "#22c55e"], ["Prospectos", resumen.prospectos, "#3b82f6"], ["Reclamos", resumen.totalReclamos, "#e63946"]].map(([lab, val, col]) => (
            <div key={lab} style={{ background: cardBg, borderRadius: "12px", padding: "1rem", border: `1px solid ${borde}`, textAlign: "center" }}>
              <p style={{ fontSize: "22px", fontWeight: "700", color: col, margin: 0 }}>{val}</p>
              <p style={{ fontSize: "11px", color: subtexto, margin: "4px 0 0" }}>{lab}</p>
            </div>
          ))}
        </div>
        <input placeholder="🔍 Buscar por nombre o código..." value={busqueda} onChange={e => setBusqueda(e.target.value)} style={{ ...inp, marginBottom: "1rem", marginTop: 0 }} />
        <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginBottom: "1rem" }}>
          <button onClick={() => setFiltroEstado("todos")} style={{ padding: "4px 10px", borderRadius: "16px", fontSize: "11px", cursor: "pointer", fontWeight: "600", border: filtroEstado === "todos" ? "2px solid #7B5BF2" : `1px solid ${borde}`, background: filtroEstado === "todos" ? "rgba(123,91,242,.1)" : cardBg, color: filtroEstado === "todos" ? "#7B5BF2" : subtexto }}>Todos</button>
          {Object.entries(estadosCliente).map(([val, { label, color }]) => (
            <button key={val} onClick={() => setFiltroEstado(val)} style={{ padding: "4px 10px", borderRadius: "16px", fontSize: "11px", cursor: "pointer", fontWeight: "600", border: filtroEstado === val ? `2px solid ${color}` : `1px solid ${borde}`, background: filtroEstado === val ? `${color}22` : cardBg, color: filtroEstado === val ? color : subtexto }}>{label}</button>
          ))}
        </div>
        {clientesFiltrados.length === 0
          ? <div style={{ textAlign: "center", padding: "4rem" }}><p style={{ fontSize: "40px" }}>👥</p><p style={{ fontSize: "15px", color: texto }}>No hay clientes registrados</p></div>
          : clientesFiltrados.map(c => (
              <div key={c.id} onClick={() => { setDetalle(c); setVista("detalle"); }}
                style={{ background: cardBg, borderRadius: "12px", padding: "1.2rem 1.5rem", border: `1px solid ${borde}`, marginBottom: "10px", cursor: "pointer" }}
                onMouseEnter={e => e.currentTarget.style.boxShadow = "0 4px 16px rgba(123,91,242,0.15)"}
                onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                  <div>
                    <span style={{ fontWeight: "700", color: "#7B5BF2", fontSize: "13px" }}>{c.codigo}</span>
                    <span style={{ marginLeft: "10px", fontSize: "13px", color: texto, fontWeight: "600" }}>{c.nombre || "Sin nombre"}</span>
                    <p style={{ fontSize: "12px", color: subtexto, marginTop: "4px" }}>{c.tipo} · {c.segmento} · {c.reclamos?.length || 0} reclamos</p>
                  </div>
                  <span style={{ fontSize: "11px", fontWeight: "700", color: estadosCliente[c.estado]?.color }}>{estadosCliente[c.estado]?.label}</span>
                </div>
                <div style={{ marginTop: "6px", fontSize: "11px", color: oscuro ? "#7B5BF2" : "#9b8cc4" }}>Contacto: {c.contacto || "—"} · {c.email || "—"}</div>
              </div>
            ))
        }
      </div>
    </div>
  );
}